import Image from "next/image";

const BannerReview = ({
  name,
  content,
  hide,
}: {
  name: string;
  content: string;
  hide?: boolean;
}): JSX.Element => {
  return (
    <>
      <div
        className={`flex ${
          hide && "md:hidden lg:flex"
        } flex-col bg-landing-gray w-full h-full lg:w-1/3 rounded-2xl p-8 justify-between`}
      >
        <div className="mb-1.5">{content}</div>
        <div className="flex flex-row justify-between">
          <div className="text-lg font-semibold">{name}</div>
          <div className="flex text-lg font-semibold">
            <Image
              src="/cutomers-reviews/star.svg"
              alt="Customer Image"
              height={19}
              width={19}
              priority
            />
            <Image
              src="/cutomers-reviews/star.svg"
              alt="Customer Image"
              height={19}
              width={19}
              priority
            />
            <Image
              src="/cutomers-reviews/star.svg"
              alt="Customer Image"
              height={19}
              width={19}
              priority
            />
            <Image
              src="/cutomers-reviews/star.svg"
              alt="Customer Image"
              height={19}
              width={19}
              priority
            />
            <Image
              src="/cutomers-reviews/star.svg"
              alt="Customer Image"
              height={19}
              width={19}
              priority
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerReview;
